import React, { useEffect, useState } from 'react'
import { FaAngleDown, FaArrowDown, FaCartArrowDown, FaHeart, FaSignInAlt, FaSignOutAlt, FaUser, FaUserAlt } from 'react-icons/fa'
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { getDomainInfo } from '../utils/utils';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import { useUser } from '../context/userContext';


export default function HeaderMainNavigation() {

    const { userId } = useParams();
    const { isPredefinedDomain, uid } = getDomainInfo(userId);
    const navigate = useNavigate();

    const location = useLocation();

    const user = useSelector((state) => state.fetchUser?.user);
    const userImg = useSelector((state) => state.fetchUser?.user?.profileImg);
    const userName = useSelector((state) => state.fetchUser?.user?.name);
    const userBio = useSelector((state) => state.fetchUser?.user?.bio);
    const userMainid = useSelector((state) => state.fetchUser?.user?.id);
    // const userPhone = useSelector((state) => state.fetchUser?.user?.phone);

    const collectionList = useSelector((state) => state.fetchCollectionInfo.sellerCollection) || [];;

    const { userData, fetchUserData } = useUser();




    const token = localStorage.getItem("token");

    // const useSelectorData = useSelector((state) => state);
    // console.log('useSelectorData', useSelectorData)

    const [cartLength, setCartLength] = useState(0);
    const cart = useSelector((state) => state.fetchCart?.cartInfo?.cartItem) || [];

    //  console.log(cart,cartLength,'cart');

    const updateCartLength = () => {
        setCartLength(cart.filter((item) => item.storeid === userMainid).length);
    };
    useEffect(() => {
        updateCartLength();
    }, [cart]);

    const defaultImageUrl = process.env.REACT_APP_S3_URL || "/assets/images/defultprofileimage.png";

    const imageUrl = userImg && userImg.includes("https://hello-image-bucket.s3")
        ? userImg
        : defaultImageUrl + userImg;

    const [imgLoaded, setImgLoaded] = useState(false);

    useEffect(() => {
        if (!imageUrl) return;

        const img = new Image();
        img.src = imageUrl;

        img.onload = () => setImgLoaded(true);
        img.onerror = () => setImgLoaded(false);
    }, [imageUrl]);


    const [searchInput, setSearchInput] = useState();
    const searchData = (e) => {
        e.preventDefault();
        navigate(isPredefinedDomain ? `/${uid}/search?qry=${searchInput}` : '/search?qry=' + searchInput)
        // alert(searchInput)
    }

    const [whatsappChatBot, setWhatsappChatBot] = useState('');
    useEffect(() => {
        setWhatsappChatBot('https://web.whatsapp.com/img/favicon/1x/favicon.png')
    }, [whatsappChatBot])


    const SignoutHandeller = async () => {
        const token = localStorage.getItem("token");
        const cartContext = localStorage.getItem("cartContext");

        if (token !== null) {


            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BACKEND_URL}customer/signout`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            cartContext: cartContext,
                            storeId: userData?.id
                        }),
                    }
                );
                const data = await response.json();
                if (response.ok) {

                    if (data.cartContext) {
                        localStorage.setItem("cartContext", data?.cartContext);

                    }
                    // localStorage.removeItem("cartContext");


                } else {
                    console.log(
                        data.message || "Verification failed. Please try again."
                    );
                }
            } catch (error) {
                console.log("An error occurred. Please try again later.");
            }
            localStorage.removeItem("token");
            localStorage.removeItem("usermob");
            localStorage.removeItem("customerId");

            //  window.location.reload()


            navigate(isPredefinedDomain ? `/${uid}/login` : "/login");
        }
    };

    function scrollToHashElement(hash, offset = 80) {
        const id = hash.replace('#', '');
        const el = document.getElementById(id);
        if (el) {
            const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: y, behavior: 'smooth' });

            // Optional: your custom logic
            console.log(`Scrolled to ${id}`);
            // yourCustomFunction(id);
        }
    }

     useEffect(() => {
    if (location.hash) {
      // Wait for DOM to be ready if components are still mounting
      setTimeout(() => scrollToHashElement(location.hash, 80), 100);
    }
  }, [location]);



    // console.log('user',user);

    // console.log('tends',user?.customRibbonInfo)
    // console.log('collection',collectionList)

    return (
        <div className="headerMainNavigation menu-layout-2">
            <div className="container">
                <div className="flex">
                    <div className="logo-box">
                        <Link to={isPredefinedDomain ? `/${uid}` : '/'}><figure>{imgLoaded && <img src={imageUrl} alt="logo" />}</figure></Link>
                    </div>
                    <div className="main-nav">
                        <ul>
                            <li><Link to={isPredefinedDomain ? `/${uid}` : '/'}>Home</Link></li>
                            <li><Link to={isPredefinedDomain ? `/${uid}/shop` : '/shop'}>Shop</Link></li>
                            <li className="has-dropdown"><Link to="#">Collection {collectionList && collectionList?.length > 0 ? <FaAngleDown /> : ''}</Link>
                                <ul className="submenu">
                                    {
                                        Array.isArray(collectionList) && collectionList?.map((v, i) => {
                                            const mkId = `${v.title.toLowerCase().replace(/['",]/g, '').replace(/[^a-z0-9\s]/g, '').trim().replace(/\s+/g, '_')}`;
                                            return <li key={i}><a href={isPredefinedDomain ? `/${uid}#${mkId}` : `#${mkId}`} onClick={(e) => {
      if (!isPredefinedDomain) {
        e.preventDefault()
        scrollToHashElement(`#${mkId}`, 80);
      }
    }}>{v.title.toLowerCase()}</a></li>
                                        })
                                    }
                                </ul>
                            </li>
                            {/* <li className="has-dropdown"><Link to="#">Top Trends  {user?.customRibbonInfo && user?.customRibbonInfo?.length > 0?<FaAngleDown/>:''}</Link>
                                <ul className="submenu">
                                    {
                                        user?.customRibbonInfo?.map((v,i)=>{
                                            return <li key={i}><Link to={`#${v.title.toLowerCase().replace(/['",]/g, '').replace(/[^a-z0-9\s]/g, '').trim().replace(/\s+/g, '_')}`}>{v.title.toLowerCase()}</Link></li>
                                        })
                                    }
                                </ul>
                            </li> */}
                            {/* <li><Link to={isPredefinedDomain ? `/${uid}/about` : '/about'}>About Us</Link></li> */}
                            <li><Link to={isPredefinedDomain ? `/${uid}/#` : '/#'}>About Us</Link></li>
                            <li><a href={isPredefinedDomain ? `/${uid}#footer` : '#footer'}>Contact Us</a></li>
                        </ul>
                    </div>
                    {/* <div className="searchbar-box">
                        <Form onSubmit={(e) => { searchData(e) }}>
                            <div className="form-grp">
                                <div className="iconBox"><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.8047 19.4453C20.0391 19.6797 20.0391 20.1094 19.8047 20.3438C19.6875 20.4609 19.5312 20.5 19.375 20.5C19.1797 20.5 19.0234 20.4609 18.8672 20.3438L13.3594 14.7969C11.9141 16.0469 10.0781 16.75 8.08594 16.75C3.63281 16.75 0 13.1172 0 8.625C0 4.17188 3.59375 0.5 8.08594 0.5C12.5391 0.5 16.2109 4.17188 16.2109 8.625C16.2109 10.6562 15.5078 12.4922 14.2578 13.9375L19.8047 19.4453ZM8.125 15.5C11.9141 15.5 15 12.4531 15 8.625C15 4.83594 11.9141 1.75 8.125 1.75C4.29688 1.75 1.25 4.83594 1.25 8.625C1.25 12.4141 4.29688 15.5 8.125 15.5Z" fill="#666666" />
                                </svg>
                                </div>
                                <input placeholder="Search our products" value={searchInput} onChange={(e) => setSearchInput(e.target.value)} />
                            </div></Form>
                    </div> */}
                    <div className="more-info">
                        <ul>
                            {/* <li className="wishlist-box"><Link to="#"><FaHeart /></Link></li> */}
                            <li className="user-box"><Link to="#"><FaUserAlt /></Link>
                                <ul>
                                    <li><Link to={token ?
                                        (isPredefinedDomain ? `/${uid}/myaccount` : '/myaccount')
                                        : (isPredefinedDomain ? `/${uid}/login` : '/login')
                                    }><FaUser /> <span>My Account</span></Link></li>
                                    {/* <li><Link to={token ?
                                        (isPredefinedDomain ? `/${uid}/myaccount` : '/myaccount')
                                        : (isPredefinedDomain ? `/${uid}/#` : '/#')
                                    }><FaHeart /> <span>Wishlist</span></Link></li> */}
                                    <li>
                                        {
                                            token ? <Link to="#" onClick={() => SignoutHandeller()}><FaSignOutAlt /><span>Logout</span></Link>
                                                : <Link to={isPredefinedDomain ? `/${uid}/login` : '/login'}><FaSignInAlt /> <span>Login</span></Link>
                                        }
                                    </li>
                                    {/* <li><Link to="#">{token ? <><FaSignOutAlt /> <span onClick={()=> SignoutHandeller}>Logout</span></>:<></>}</Link></li> */}
                                </ul>
                            </li>
                            {!location.pathname.includes('/cart') && (
                                <li className="cart-box custom-badge">
                                    <button
                                    onClick={() => {
                                        navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
                                        setTimeout(() => {
                                        window.location.reload();
                                        }, 100);
                                    }}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                        padding: 0,
                                    }}
                                    >
                                    <ShoppingCartOutlinedIcon fontSize="large" />
                                    <sup className="MuiBadge-badge">{cartLength}</sup>
                                    </button>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
            {/* <a href={`https://wa.me/${userPhone}`} className="whatsapp-float" target="_blank"><img src="/assets/images/whatsapp.png" alt="Chat on WhatsApp" width="50" /></a> */}
        </div>
    )
}
